import dictionaryCompletions from './dictionaryCompletions'

const english = {
  'language.selector.label': 'Language',
  'language.selector.help': 'Choose screen language',
  'nav.admin': 'Admin',
  'nav.fit3dAdmin': 'Fit3D Admin',
  'nav.facility': 'Facility',
  'nav.fitness': 'Fitness',
  'nav.history': 'History',
  'nav.market': 'Market',
  'nav.marketplace': 'Marketplace',
  'nav.account': 'Account',
  'nav.survey': 'Survey',
  'nav.scanHistory': 'Scan History',
  'nav.dashboard': 'Dashboard',
  'nav.myClients': 'My Clients',
  'nav.clientScans': 'Client Scans',
  'nav.demoReport': 'Demo Report',
  'nav.demoComparison': 'Demo Comparison',
  'nav.manageCoaches': 'Manage Coaches',
  'nav.results': 'Results',
  'nav.scan': 'Scan',
  'nav.wellness': 'Wellness',
  'nav.posture': 'Posture',
  'nav.balance': 'Balance',
  'nav.measurements': 'Measurements',
  'nav.printable': 'Printable',
  'nav.comparison': 'Comparison',
  'nav.glossary': 'Glossary',
  'nav.myProfile': 'My Profile',
  'nav.myCoaches': 'My Coaches',
  'nav.help': 'Help',
  'nav.logout': 'Logout',
  'nav.records': 'Records',
  'nav.snapFailures': 'Snap Failures',
  'nav.qc': 'QC',
  'nav.facilities': 'Facilities',
  'nav.scanners': 'Scanners',
  'nav.coaches': 'Coaches',
  'nav.users': 'Users',
  'nav.version': 'Version',
  'nav.client': 'Client',
  'nav.report': 'Report',
  'nav.overlay': 'Overlay',
  'nav.downloadMeasurements': 'Download Measurements',
  'cookie.notice':
    'This website stores cookies on your computer. These cookies are used to collect information about how you interact with our website and allow us to remember you. We use this information in order to improve and customize your browsing experience and for analytics and metrics about our visitors both on this website and other media. To find out more about the cookies we use, see our',
  'cookie.privacyPolicy': 'Privacy Policy',
  'cookie.accept': 'Got it, thanks.',
  'common.notFound': 'Not Found',
  'dashboard.successHub': 'Success Hub',
  'dashboard.usageDashboard': 'Usage Dashboard',
  'dashboard.summary': 'Summary',
  'dashboard.users': 'Users',
  'dashboard.coaches': 'Coaches',
  'dashboard.scans': 'Scans',
  'dashboard.parqs': 'PARQs',
  'dashboard.parq': 'ParQ',
  'dashboard.wins': 'Wins',
  'dashboard.win': 'Win',
  'dashboard.winRate': 'Win Rate',
  'dashboard.coachActivity': 'Coach Activity',
  'dashboard.coachActivityMonthly': 'Coach Activity (Monthly)',
  'dashboard.newUsers': 'New Users',
  'dashboard.newUsersMonthly': 'New Users (Monthly)',
  'dashboard.activeUsers': 'Active Users',
  'dashboard.activeUsersMonthly': 'Active Users (Monthly)',
  'dashboard.newScans': 'New Scans',
  'dashboard.newScansMonthly': 'New Scans (Monthly)',
  'dashboard.maybe': 'Maybe',
  'dashboard.no': 'No',
  'dashboard.month': 'Month',
  'dashboard.coachActivityLeaders': 'Coach Activity Leaders',
  'dashboard.coachLeadersCurrentMonth': 'Coach Leaders (Current Month)',
  'dashboard.coachLeadersAllTime': 'Coach Leaders (All Time)',
  'dashboard.whatIsThis': 'What is this?',
  'dashboard.coachLeadersExplanation':
    'Coaches are ranked based on their ParQs completed and Wins (potential clients they have marked as interested).',
  'dashboard.notAvailable': 'N/A',
}

const translations = {
  fr: {
    'language.selector.label': 'Langue',
    'language.selector.help': "Choisir la langue de l'écran",
    'nav.admin': 'Admin',
    'nav.fit3dAdmin': 'Admin Fit3D',
    'nav.facility': 'Établissement',
    'nav.fitness': 'Forme',
    'nav.history': 'Historique',
    'nav.market': 'Marché',
    'nav.marketplace': 'Marketplace',
    'nav.account': 'Compte',
    'nav.survey': 'Sondage',
    'nav.scanHistory': 'Historique des scans',
    'nav.dashboard': 'Tableau de bord',
    'nav.myClients': 'Mes clients',
    'nav.clientScans': 'Scans client',
    'nav.demoReport': 'Rapport démo',
    'nav.demoComparison': 'Comparaison démo',
    'nav.manageCoaches': 'Gérer les coachs',
    'nav.results': 'Résultats',
    'nav.scan': 'Scan',
    'nav.wellness': 'Bien-être',
    'nav.posture': 'Posture',
    'nav.balance': 'Équilibre',
    'nav.measurements': 'Mesures',
    'nav.printable': 'Imprimable',
    'nav.comparison': 'Comparaison',
    'nav.glossary': 'Glossaire',
    'nav.myProfile': 'Mon profil',
    'nav.myCoaches': 'Mes coachs',
    'nav.help': 'Aide',
    'nav.logout': 'Déconnexion',
    'nav.records': 'Dossiers',
    'nav.facilities': 'Établissements',
    'nav.scanners': 'Scanners',
    'nav.coaches': 'Coachs',
    'nav.users': 'Utilisateurs',
    'nav.version': 'Version',
    'nav.client': 'Client',
    'nav.report': 'Rapport',
    'nav.overlay': 'Superposition',
    'nav.downloadMeasurements': 'Télécharger les mesures',
    'cookie.privacyPolicy': 'Politique de confidentialité',
    'cookie.accept': "J'ai compris, merci.",
    'common.notFound': 'Introuvable',
  },
  de: {
    'language.selector.label': 'Sprache',
    'language.selector.help': 'Bildschirmsprache auswählen',
    'nav.admin': 'Admin',
    'nav.fit3dAdmin': 'Fit3D-Admin',
    'nav.facility': 'Einrichtung',
    'nav.fitness': 'Fitness',
    'nav.history': 'Verlauf',
    'nav.market': 'Markt',
    'nav.marketplace': 'Marktplatz',
    'nav.account': 'Konto',
    'nav.survey': 'Umfrage',
    'nav.scanHistory': 'Scanverlauf',
    'nav.dashboard': 'Dashboard',
    'nav.myClients': 'Meine Kunden',
    'nav.clientScans': 'Kundenscans',
    'nav.demoReport': 'Demo-Bericht',
    'nav.demoComparison': 'Demo-Vergleich',
    'nav.manageCoaches': 'Coaches verwalten',
    'nav.results': 'Ergebnisse',
    'nav.scan': 'Scan',
    'nav.wellness': 'Wellness',
    'nav.posture': 'Haltung',
    'nav.balance': 'Balance',
    'nav.measurements': 'Messungen',
    'nav.printable': 'Druckbar',
    'nav.comparison': 'Vergleich',
    'nav.glossary': 'Glossar',
    'nav.myProfile': 'Mein Profil',
    'nav.myCoaches': 'Meine Coaches',
    'nav.help': 'Hilfe',
    'nav.logout': 'Abmelden',
    'nav.records': 'Datensätze',
    'nav.facilities': 'Einrichtungen',
    'nav.scanners': 'Scanner',
    'nav.coaches': 'Coaches',
    'nav.users': 'Benutzer',
    'nav.version': 'Version',
    'nav.client': 'Kunde',
    'nav.report': 'Bericht',
    'nav.overlay': 'Überlagerung',
    'nav.downloadMeasurements': 'Messungen herunterladen',
    'cookie.privacyPolicy': 'Datenschutzrichtlinie',
    'cookie.accept': 'Verstanden, danke.',
    'common.notFound': 'Nicht gefunden',
    'dashboard.successHub': 'Success Hub',
    'dashboard.usageDashboard': 'Nutzungsübersicht',
    'dashboard.summary': 'Zusammenfassung',
    'dashboard.users': 'Benutzer',
    'dashboard.coaches': 'Trainer',
    'dashboard.scans': 'Körperscans',
    'dashboard.parqs': 'PARQ-Fragebögen',
    'dashboard.parq': 'ParQ',
    'dashboard.wins': 'Gewinne',
    'dashboard.win': 'Gewinn',
    'dashboard.winRate': 'Gewinnrate',
    'dashboard.coachActivity': 'Traineraktivität',
    'dashboard.coachActivityMonthly': 'Traineraktivität (monatlich)',
    'dashboard.newUsers': 'Neue Benutzer',
    'dashboard.newUsersMonthly': 'Neue Benutzer (monatlich)',
    'dashboard.activeUsers': 'Aktive Benutzer',
    'dashboard.activeUsersMonthly': 'Aktive Benutzer (monatlich)',
    'dashboard.newScans': 'Neue Körperscans',
    'dashboard.newScansMonthly': 'Neue Körperscans (monatlich)',
    'dashboard.maybe': 'Vielleicht',
    'dashboard.no': 'Nein',
    'dashboard.month': 'Monat',
    'dashboard.coachActivityLeaders': 'Führende Traineraktivität',
    'dashboard.coachLeadersCurrentMonth': 'Trainer-Rangliste (aktueller Monat)',
    'dashboard.coachLeadersAllTime': 'Trainer-Rangliste (gesamt)',
    'dashboard.whatIsThis': 'Was ist das?',
    'dashboard.coachLeadersExplanation':
      'Trainer werden nach abgeschlossenen ParQs und Erfolgen bewertet (potenzielle Kunden, die sie als interessiert markiert haben).',
    'dashboard.notAvailable': 'N/V',
  },
  es: {
    'language.selector.label': 'Idioma',
    'language.selector.help': 'Elegir idioma de pantalla',
    'nav.admin': 'Admin',
    'nav.fit3dAdmin': 'Admin de Fit3D',
    'nav.facility': 'Centro',
    'nav.fitness': 'Fitness',
    'nav.history': 'Historial',
    'nav.market': 'Mercado',
    'nav.marketplace': 'Marketplace',
    'nav.account': 'Cuenta',
    'nav.survey': 'Encuesta',
    'nav.scanHistory': 'Historial de escaneos',
    'nav.dashboard': 'Panel',
    'nav.myClients': 'Mis clientes',
    'nav.clientScans': 'Escaneos de clientes',
    'nav.demoReport': 'Informe demo',
    'nav.demoComparison': 'Comparación demo',
    'nav.manageCoaches': 'Gestionar entrenadores',
    'nav.results': 'Resultados',
    'nav.scan': 'Escaneo',
    'nav.wellness': 'Bienestar',
    'nav.posture': 'Postura',
    'nav.balance': 'Equilibrio',
    'nav.measurements': 'Medidas',
    'nav.printable': 'Imprimible',
    'nav.comparison': 'Comparación',
    'nav.glossary': 'Glosario',
    'nav.myProfile': 'Mi perfil',
    'nav.myCoaches': 'Mis entrenadores',
    'nav.help': 'Ayuda',
    'nav.logout': 'Cerrar sesión',
    'nav.records': 'Registros',
    'nav.facilities': 'Centros',
    'nav.scanners': 'Escáneres',
    'nav.coaches': 'Entrenadores',
    'nav.users': 'Usuarios',
    'nav.version': 'Versión',
    'nav.client': 'Cliente',
    'nav.report': 'Informe',
    'nav.overlay': 'Superposición',
    'nav.downloadMeasurements': 'Descargar medidas',
    'cookie.privacyPolicy': 'Política de privacidad',
    'cookie.accept': 'Entendido, gracias.',
    'common.notFound': 'No encontrado',
  },
  pt: {
    'language.selector.label': 'Idioma',
    'language.selector.help': 'Escolher idioma da tela',
    'nav.admin': 'Admin',
    'nav.fit3dAdmin': 'Admin Fit3D',
    'nav.facility': 'Instalação',
    'nav.fitness': 'Fitness',
    'nav.history': 'Histórico',
    'nav.market': 'Mercado',
    'nav.marketplace': 'Marketplace',
    'nav.account': 'Conta',
    'nav.survey': 'Pesquisa',
    'nav.scanHistory': 'Histórico de scans',
    'nav.dashboard': 'Painel',
    'nav.myClients': 'Meus clientes',
    'nav.clientScans': 'Scans de clientes',
    'nav.demoReport': 'Relatório demo',
    'nav.demoComparison': 'Comparação demo',
    'nav.manageCoaches': 'Gerenciar coaches',
    'nav.results': 'Resultados',
    'nav.scan': 'Scan',
    'nav.wellness': 'Bem-estar',
    'nav.posture': 'Postura',
    'nav.balance': 'Equilíbrio',
    'nav.measurements': 'Medidas',
    'nav.printable': 'Imprimível',
    'nav.comparison': 'Comparação',
    'nav.glossary': 'Glossário',
    'nav.myProfile': 'Meu perfil',
    'nav.myCoaches': 'Meus coaches',
    'nav.help': 'Ajuda',
    'nav.logout': 'Sair',
    'nav.records': 'Registros',
    'nav.facilities': 'Instalações',
    'nav.scanners': 'Scanners',
    'nav.coaches': 'Coaches',
    'nav.users': 'Usuários',
    'nav.version': 'Versão',
    'nav.client': 'Cliente',
    'nav.report': 'Relatório',
    'nav.overlay': 'Sobreposição',
    'nav.downloadMeasurements': 'Baixar medidas',
    'cookie.privacyPolicy': 'Política de Privacidade',
    'cookie.accept': 'Entendi, obrigado.',
    'common.notFound': 'Não encontrado',
  },
  zh_CN: {
    'language.selector.label': '语言',
    'language.selector.help': '选择界面语言',
    'nav.facility': '场馆',
    'nav.fitness': '健身',
    'nav.history': '历史',
    'nav.account': '账户',
    'nav.scanHistory': '扫描历史',
    'nav.dashboard': '仪表板',
    'nav.myClients': '我的客户',
    'nav.results': '结果',
    'nav.scan': '扫描',
    'nav.wellness': '健康',
    'nav.posture': '姿势',
    'nav.balance': '平衡',
    'nav.measurements': '测量',
    'nav.comparison': '比较',
    'nav.glossary': '术语表',
    'nav.myProfile': '我的资料',
    'nav.help': '帮助',
    'nav.logout': '退出',
    'cookie.privacyPolicy': '隐私政策',
    'cookie.accept': '知道了，谢谢。',
    'common.notFound': '未找到',
  },
  zh_TW: {
    'language.selector.label': '語言',
    'language.selector.help': '選擇介面語言',
    'nav.facility': '場館',
    'nav.fitness': '健身',
    'nav.history': '歷史',
    'nav.account': '帳戶',
    'nav.scanHistory': '掃描歷史',
    'nav.dashboard': '儀表板',
    'nav.myClients': '我的客戶',
    'nav.results': '結果',
    'nav.scan': '掃描',
    'nav.wellness': '健康',
    'nav.posture': '姿勢',
    'nav.balance': '平衡',
    'nav.measurements': '測量',
    'nav.comparison': '比較',
    'nav.glossary': '術語表',
    'nav.myProfile': '我的資料',
    'nav.help': '說明',
    'nav.logout': '登出',
    'cookie.privacyPolicy': '隱私權政策',
    'cookie.accept': '知道了，謝謝。',
    'common.notFound': '找不到',
  },
  it: {
    'language.selector.label': 'Lingua',
    'language.selector.help': 'Scegli la lingua dello schermo',
    'nav.facility': 'Struttura',
    'nav.fitness': 'Fitness',
    'nav.history': 'Cronologia',
    'nav.account': 'Account',
    'nav.scanHistory': 'Cronologia scansioni',
    'nav.dashboard': 'Pannello',
    'nav.myClients': 'I miei clienti',
    'nav.clientScans': 'Scansioni clienti',
    'nav.demoReport': 'Rapporto demo',
    'nav.demoComparison': 'Confronto demo',
    'nav.manageCoaches': 'Gestisci allenatori',
    'nav.results': 'Risultati',
    'nav.scan': 'Scansione',
    'nav.wellness': 'Benessere',
    'nav.posture': 'Postura',
    'nav.balance': 'Equilibrio',
    'nav.measurements': 'Misure',
    'nav.printable': 'Stampabile',
    'nav.comparison': 'Confronto',
    'nav.glossary': 'Glossario',
    'nav.myProfile': 'Il mio profilo',
    'nav.myCoaches': 'I miei allenatori',
    'nav.help': 'Aiuto',
    'nav.logout': 'Esci',
    'nav.client': 'Cliente',
    'nav.report': 'Rapporto',
    'nav.downloadMeasurements': 'Scarica misure',
    'cookie.privacyPolicy': 'Informativa sulla privacy',
    'cookie.accept': 'Capito, grazie.',
    'common.notFound': 'Non trovato',
    'dashboard.successHub': 'Success Hub',
    'dashboard.usageDashboard': 'Dashboard utilizzo',
    'dashboard.summary': 'Riepilogo',
    'dashboard.users': 'Utenti',
    'dashboard.coaches': 'Allenatori',
    'dashboard.scans': 'Scansioni',
    'dashboard.parqs': 'PARQs',
    'dashboard.parq': 'ParQ',
    'dashboard.wins': 'Vittorie',
    'dashboard.win': 'Vittoria',
    'dashboard.winRate': 'Tasso di vittoria',
    'dashboard.coachActivity': 'Attività degli allenatori',
    'dashboard.coachActivityMonthly': 'Attività degli allenatori (mensile)',
    'dashboard.newUsers': 'Nuovi utenti',
    'dashboard.newUsersMonthly': 'Nuovi utenti (mensile)',
    'dashboard.activeUsers': 'Utenti attivi',
    'dashboard.activeUsersMonthly': 'Utenti attivi (mensile)',
    'dashboard.newScans': 'Nuove scansioni',
    'dashboard.newScansMonthly': 'Nuove scansioni (mensile)',
    'dashboard.maybe': 'Forse',
    'dashboard.no': 'No',
    'dashboard.month': 'Mese',
    'dashboard.coachActivityLeaders': 'Leader per attività degli allenatori',
    'dashboard.coachLeadersCurrentMonth': 'Leader allenatori (mese corrente)',
    'dashboard.coachLeadersAllTime': 'Leader allenatori (totale)',
    'dashboard.whatIsThis': "Che cos'è?",
    'dashboard.coachLeadersExplanation':
      'Gli allenatori sono classificati in base ai ParQ completati e alle vittorie (potenziali clienti contrassegnati come interessati).',
    'dashboard.notAvailable': 'N/D',
  },
  ko: {
    'language.selector.label': '언어',
    'language.selector.help': '화면 언어 선택',
    'nav.facility': '시설',
    'nav.fitness': '피트니스',
    'nav.history': '기록',
    'nav.account': '계정',
    'nav.scanHistory': '스캔 기록',
    'nav.dashboard': '대시보드',
    'nav.myClients': '내 고객',
    'nav.results': '결과',
    'nav.scan': '스캔',
    'nav.wellness': '웰니스',
    'nav.posture': '자세',
    'nav.balance': '균형',
    'nav.measurements': '측정',
    'nav.comparison': '비교',
    'nav.glossary': '용어집',
    'nav.myProfile': '내 프로필',
    'nav.help': '도움말',
    'nav.logout': '로그아웃',
    'cookie.privacyPolicy': '개인정보 처리방침',
    'cookie.accept': '알겠습니다, 감사합니다.',
    'common.notFound': '찾을 수 없음',
  },
  nl: {
    'language.selector.label': 'Taal',
    'language.selector.help': 'Schermtaal kiezen',
    'nav.facility': 'Faciliteit',
    'nav.fitness': 'Fitness',
    'nav.history': 'Geschiedenis',
    'nav.account': 'Account',
    'nav.scanHistory': 'Scangeschiedenis',
    'nav.dashboard': 'Dashboard',
    'nav.myClients': 'Mijn klanten',
    'nav.results': 'Resultaten',
    'nav.scan': 'Scan',
    'nav.wellness': 'Welzijn',
    'nav.posture': 'Houding',
    'nav.balance': 'Balans',
    'nav.measurements': 'Metingen',
    'nav.comparison': 'Vergelijking',
    'nav.glossary': 'Woordenlijst',
    'nav.myProfile': 'Mijn profiel',
    'nav.help': 'Help',
    'nav.logout': 'Uitloggen',
    'cookie.privacyPolicy': 'Privacybeleid',
    'cookie.accept': 'Begrepen, bedankt.',
    'common.notFound': 'Niet gevonden',
  },
  fi: {
    'language.selector.label': 'Kieli',
    'language.selector.help': 'Valitse näytön kieli',
    'nav.facility': 'Toimipiste',
    'nav.fitness': 'Kunto',
    'nav.history': 'Historia',
    'nav.account': 'Tili',
    'nav.scanHistory': 'Skannaushistoria',
    'nav.dashboard': 'Hallintapaneeli',
    'nav.myClients': 'Asiakkaani',
    'nav.results': 'Tulokset',
    'nav.scan': 'Skannaus',
    'nav.wellness': 'Hyvinvointi',
    'nav.posture': 'Ryhti',
    'nav.balance': 'Tasapaino',
    'nav.measurements': 'Mitat',
    'nav.comparison': 'Vertailu',
    'nav.glossary': 'Sanasto',
    'nav.myProfile': 'Profiilini',
    'nav.help': 'Ohje',
    'nav.logout': 'Kirjaudu ulos',
    'cookie.privacyPolicy': 'Tietosuojakäytäntö',
    'cookie.accept': 'Selvä, kiitos.',
    'common.notFound': 'Ei löytynyt',
  },
  ru: {
    'language.selector.label': 'Язык',
    'language.selector.help': 'Выберите язык экрана',
    'nav.facility': 'Объект',
    'nav.fitness': 'Фитнес',
    'nav.history': 'История',
    'nav.account': 'Аккаунт',
    'nav.scanHistory': 'История сканов',
    'nav.dashboard': 'Панель',
    'nav.myClients': 'Мои клиенты',
    'nav.results': 'Результаты',
    'nav.scan': 'Скан',
    'nav.wellness': 'Здоровье',
    'nav.posture': 'Осанка',
    'nav.balance': 'Баланс',
    'nav.measurements': 'Измерения',
    'nav.comparison': 'Сравнение',
    'nav.glossary': 'Глоссарий',
    'nav.myProfile': 'Мой профиль',
    'nav.help': 'Помощь',
    'nav.logout': 'Выйти',
    'cookie.privacyPolicy': 'Политика конфиденциальности',
    'cookie.accept': 'Понятно, спасибо.',
    'common.notFound': 'Не найдено',
  },
  sv: {
    'language.selector.label': 'Språk',
    'language.selector.help': 'Välj skärmspråk',
    'nav.facility': 'Anläggning',
    'nav.fitness': 'Fitness',
    'nav.history': 'Historik',
    'nav.account': 'Konto',
    'nav.scanHistory': 'Skanningshistorik',
    'nav.dashboard': 'Instrumentpanel',
    'nav.myClients': 'Mina kunder',
    'nav.results': 'Resultat',
    'nav.scan': 'Skanning',
    'nav.wellness': 'Välmående',
    'nav.posture': 'Hållning',
    'nav.balance': 'Balans',
    'nav.measurements': 'Mått',
    'nav.comparison': 'Jämförelse',
    'nav.glossary': 'Ordlista',
    'nav.myProfile': 'Min profil',
    'nav.help': 'Hjälp',
    'nav.logout': 'Logga ut',
    'cookie.privacyPolicy': 'Integritetspolicy',
    'cookie.accept': 'Jag förstår, tack.',
    'common.notFound': 'Hittades inte',
  },
  ja: {
    'language.selector.label': '言語',
    'language.selector.help': '画面の言語を選択',
    'nav.facility': '施設',
    'nav.fitness': 'フィットネス',
    'nav.history': '履歴',
    'nav.account': 'アカウント',
    'nav.scanHistory': 'スキャン履歴',
    'nav.dashboard': 'ダッシュボード',
    'nav.myClients': '顧客',
    'nav.results': '結果',
    'nav.scan': 'スキャン',
    'nav.wellness': 'ウェルネス',
    'nav.posture': '姿勢',
    'nav.balance': 'バランス',
    'nav.measurements': '測定',
    'nav.comparison': '比較',
    'nav.glossary': '用語集',
    'nav.myProfile': 'プロフィール',
    'nav.help': 'ヘルプ',
    'nav.logout': 'ログアウト',
    'cookie.privacyPolicy': 'プライバシーポリシー',
    'cookie.accept': '了解しました。',
    'common.notFound': '見つかりません',
  },
  tr: {
    'language.selector.label': 'Dil',
    'language.selector.help': 'Ekran dilini seç',
    'nav.facility': 'Tesis',
    'nav.fitness': 'Fitness',
    'nav.history': 'Geçmiş',
    'nav.account': 'Hesap',
    'nav.scanHistory': 'Tarama geçmişi',
    'nav.dashboard': 'Panel',
    'nav.myClients': 'Müşterilerim',
    'nav.results': 'Sonuçlar',
    'nav.scan': 'Tarama',
    'nav.wellness': 'Sağlık',
    'nav.posture': 'Duruş',
    'nav.balance': 'Denge',
    'nav.measurements': 'Ölçümler',
    'nav.comparison': 'Karşılaştırma',
    'nav.glossary': 'Sözlük',
    'nav.myProfile': 'Profilim',
    'nav.help': 'Yardım',
    'nav.logout': 'Çıkış',
    'cookie.privacyPolicy': 'Gizlilik Politikası',
    'cookie.accept': 'Anladım, teşekkürler.',
    'common.notFound': 'Bulunamadı',
  },
  cs: {
    'language.selector.label': 'Jazyk',
    'language.selector.help': 'Vybrat jazyk obrazovky',
    'nav.facility': 'Zařízení',
    'nav.fitness': 'Fitness',
    'nav.history': 'Historie',
    'nav.account': 'Účet',
    'nav.scanHistory': 'Historie skenů',
    'nav.dashboard': 'Přehled',
    'nav.myClients': 'Moji klienti',
    'nav.results': 'Výsledky',
    'nav.scan': 'Sken',
    'nav.wellness': 'Wellness',
    'nav.posture': 'Držení těla',
    'nav.balance': 'Rovnováha',
    'nav.measurements': 'Měření',
    'nav.comparison': 'Porovnání',
    'nav.glossary': 'Slovník',
    'nav.myProfile': 'Můj profil',
    'nav.help': 'Nápověda',
    'nav.logout': 'Odhlásit',
    'cookie.privacyPolicy': 'Zásady ochrany osobních údajů',
    'cookie.accept': 'Rozumím, děkuji.',
    'common.notFound': 'Nenalezeno',
  },
  el: {
    'language.selector.label': 'Γλώσσα',
    'language.selector.help': 'Επιλογή γλώσσας οθόνης',
    'nav.facility': 'Εγκατάσταση',
    'nav.fitness': 'Fitness',
    'nav.history': 'Ιστορικό',
    'nav.account': 'Λογαριασμός',
    'nav.scanHistory': 'Ιστορικό σαρώσεων',
    'nav.dashboard': 'Πίνακας',
    'nav.myClients': 'Οι πελάτες μου',
    'nav.results': 'Αποτελέσματα',
    'nav.scan': 'Σάρωση',
    'nav.wellness': 'Ευεξία',
    'nav.posture': 'Στάση',
    'nav.balance': 'Ισορροπία',
    'nav.measurements': 'Μετρήσεις',
    'nav.comparison': 'Σύγκριση',
    'nav.glossary': 'Γλωσσάρι',
    'nav.myProfile': 'Το προφίλ μου',
    'nav.help': 'Βοήθεια',
    'nav.logout': 'Αποσύνδεση',
    'cookie.privacyPolicy': 'Πολιτική απορρήτου',
    'cookie.accept': 'Κατάλαβα, ευχαριστώ.',
    'common.notFound': 'Δεν βρέθηκε',
  },
  hr: {
    'language.selector.label': 'Jezik',
    'language.selector.help': 'Odaberite jezik zaslona',
    'nav.facility': 'Objekt',
    'nav.fitness': 'Fitness',
    'nav.history': 'Povijest',
    'nav.account': 'Račun',
    'nav.scanHistory': 'Povijest skeniranja',
    'nav.dashboard': 'Nadzorna ploča',
    'nav.myClients': 'Moji klijenti',
    'nav.results': 'Rezultati',
    'nav.scan': 'Skeniranje',
    'nav.wellness': 'Wellness',
    'nav.posture': 'Držanje',
    'nav.balance': 'Ravnoteža',
    'nav.measurements': 'Mjerenja',
    'nav.comparison': 'Usporedba',
    'nav.glossary': 'Pojmovnik',
    'nav.myProfile': 'Moj profil',
    'nav.help': 'Pomoć',
    'nav.logout': 'Odjava',
    'cookie.privacyPolicy': 'Pravila privatnosti',
    'cookie.accept': 'Razumijem, hvala.',
    'common.notFound': 'Nije pronađeno',
  },
}

export default {
  en: english,
  ...Object.fromEntries(
    Object.entries(translations).map(([code, dictionary]) => [
      code,
      { ...dictionary, ...(dictionaryCompletions[code] || {}) },
    ])
  ),
}
